import React from 'react';
import { useTranslation } from 'react-i18next';
import Sellers from 'components/SellerSettings';
import PrivateComponent from 'composers/PrivateComponent';
import { UserRole } from 'domains/user';
import { SectionWrapper } from 'pages/SettingsPage/ProfilePage.styled';
import { Flex, PaddingBox, Text } from 'UI';

export const SellerSettings = () => {
  const { t } = useTranslation();

  return (
    <PrivateComponent
      render={() => (
        <PaddingBox py={25}>
          <SectionWrapper>
            <Flex direction={'column'} gap={25}>
              <Text type="heading4">{t('settings.seller.title', 'Request seller')}</Text>
              <Sellers />
            </Flex>
          </SectionWrapper>
        </PaddingBox>
      )}
      requiredRights={[UserRole.COMMAND]}
    />
  );
};
